module.exports = __webpack_public_path__ + "img/24.7b83f2d3.png";